/**
 * Unified entry for “protection” (DNS filtering) across Android / iOS / web (no-op).
 */

import { Platform } from "react-native";
import * as Android from "../utils/androidScreenTime";
import * as IOS from "../utils/iosScreenTime";
import { serializeRulesForNative } from "../blocking/rulesEngine";
import { saveLastRulesSyncAtMs, saveLastSyncedRulesJson } from "../storage/rulesRepository";

export function protectionAvailable() {
  if (Platform.OS === "android") return Android.androidScreenTimeSupported();
  if (Platform.OS === "ios") return IOS.iosScreenTimeSupported();
  return false;
}

export async function startProtection() {
  if (Platform.OS === "android") return Android.startDnsVpn();
  if (Platform.OS === "ios") return IOS.startDnsFiltering();
  return false;
}

export async function stopProtection() {
  if (Platform.OS === "android") return Android.stopDnsVpn();
  if (Platform.OS === "ios") return IOS.stopDnsFiltering();
  return false;
}

export async function isProtectionRunning() {
  if (Platform.OS === "android") return Android.isDnsVpnRunning();
  if (Platform.OS === "ios") return IOS.isProtectionActive();
  return false;
}

/** Push rules to the native layer (VPN / Network Extension). */
export async function syncRules(blockList, allowList, keywordList, categoryRules = {}, extras = {}) {
  const json = serializeRulesForNative({
    block: blockList || [],
    allow: allowList || [],
    keywords: keywordList || [],
    categoryRules,
    safeMode: extras.safeMode !== false,
  });
  try {
    await saveLastSyncedRulesJson(json);
    await saveLastRulesSyncAtMs(Date.now());
  } catch {
    /* ignore */
  }
  if (Platform.OS === "android") {
    Android.updateVpnRulesJson(json);
    return;
  }
  if (Platform.OS === "ios") {
    IOS.syncRulesToExtension(json);
  }
}
